export const getCartesianCoordinateSystem = (api) => {
    const system = api === null || api === void 0 ? void 0 : api.getCoordinateSystems().find((a) => { var _a; return ((_a = a.model) === null || _a === void 0 ? void 0 : _a.type) === 'grid'; });
    if (!system) {
        throw new Error('Could not find coordinate system');
    }
    return system;
};
